require('./sidebar-toggle.component.scss');

class SidebarToggleController {
  constructor(
    $scope,
    $rootScope,
    PermissionService,
    RouterService,
    CurrentFilterService,
  ) {
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.CurrentFilterService = CurrentFilterService;
    window.isPaneOpen = true;
  }

  isPaneOpen() {
    return window.isPaneOpen;
  }

  switchPanel() {
    angular.element(document).trigger('showDimensions');
  }

  get panel() {
    return this.CurrentFilterService.panel;
  }
}

export const SidebarToggleComponent = {
  template  : require('./sidebar-toggle.component.html'),
  controller: SidebarToggleController,
};



// WEBPACK FOOTER //
// ./src/layout/sidebar-toggle.component.js